module.exports = __webpack_public_path__ + "static/wh-4abd05fa6cf6b27b52d79a58828b009b.png";